import React from 'react';
import Skeleton from '../Skeleton/Skeleton';
import { cx } from '../utils';
import '../Table/Table.css';
import './TableSkeleton.css';

const range = (count) => Array.from({ length: Math.max(0, count) }, (_, index) => index);

// Jadval yuklanayotganda ko'rsatiladi: rows × cols katakli skeleton.
function TableSkeleton({ rows = 5, cols = 4, className, ...rest }) {
  return (
    <div {...rest} className={cx('ui-table-wrap', className)} aria-busy="true" aria-label="Yuklanmoqda">
      <table className="ui-table ui-table-skeleton">
        <thead>
          <tr>
            {range(cols).map((col) => (
              <th key={col}>
                <Skeleton width="60%" height={12} radius="sm" />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {range(rows).map((row) => (
            <tr key={row}>
              {range(cols).map((col) => (
                <td key={col}>
                  <Skeleton width={col === 0 ? '80%' : '55%'} height={14} radius="sm" />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default TableSkeleton;
